<!--
@Author: Calvin Green <calvin>
@Date:   2022-03-18T14:07:39+02:00
@Email:  calvin@diversitude.com
@Last modified by:   calvin
@Last modified time: 2022-04-11T13:50:49+02:00
@Copyright: Diversitude 2022
-->

<template>
    <b-card no-body>
        <template #header>
            <strong>
                {{ componentTitle }}
            </strong>
        </template>

        <div class="p-1">
            <Suppliers v-if="facility_view === 'suppliers'"/>
            <Locations v-if="facility_view === 'locations'"/>
            <Audit v-if="facility_view === 'audit'"/>
        </div>
        
    </b-card>
</template>

<script>
import { facilityAdminState, facilityAdminMethods } from '@/state/helpers'
//import Assets from './components/assets.vue'
//import Consumables from './components/consumables.vue'
import Locations from './components/locations/locations.vue'
import Suppliers from './components/suppliers/suppliers.vue'
import Audit from './components/audit/audit.vue'
export default {
    data:() => ({}),
    components:{
        //Assets,
        //Consumables,
        Locations,
        Suppliers,
        Audit
    },
    computed:{
        ...facilityAdminState,
        componentTitle(){
            switch(this.facility_view){
                
                case 'assets':{
                    return 'Assets';
                }
                case 'consumables':{
                    return 'Consumables';
                }
                case 'locations':{
                    return 'Locations';
                }
                case 'suppliers':{
                    return 'Suppliers';
                }
                case 'audit':{
                    return 'Audits';
                }
                default:{
                    return '';
                }
            }
        }
    },
    methods:{
        ...facilityAdminMethods,
    },
    mounted(){
        //* Set a default view
        if(this.facility_view === 'none'){
            this.setFacilityView('suppliers');
        }
    },
    beforeDestroy(){
        this.setFacilityView('none')
    }
}
</script>

<style>

</style>
